import React, { Component } from "react";

import Api from "../../../lib/componentApi";

import ListDesktop from "./ListDesktop";

class SearchDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popularCategories: [],
      notPopularCategories: [],
      regexCategories: [],
      selectedCategory: "",
      uid: "",
      selectedType: "",
      query: ""
    };
  }
  componentDidMount() {
    Api.get("/api/categories", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-desktop-search");
      } else {
        if (response.length) {
          this.setState({
            popularCategories: response.filter(category => category.isPopular),
            notPopularCategories: response.filter(
              category => !category.isPopular
            )
          });
        }
      }
    });
  }
  onSelectCategory = (
    categoryName,
    type,
    uid,
    restaurantPostCode,
    restaurantAdminWard,
    restaurantCity,
    slugName
  ) => {
    if (categoryName === "My Favorites") {
      location.href = "/profile?favorites";
    } else {
      const { onSubmitCategory } = this.props;
      onSubmitCategory(
        categoryName,
        type,
        uid,
        restaurantPostCode,
        restaurantAdminWard,
        restaurantCity,
        slugName
      );
    }
  };
  onRemoveQuery = () => {
    const { onRemoveQuery } = this.props;
    onRemoveQuery();
  };
  render() {
    const { popularCategories, notPopularCategories } = this.state;
    const { regexCategories } = this.props;
    return (
      <div>
        <ListDesktop
          popularCategories={popularCategories}
          notPopularCategories={notPopularCategories}
          handleSelectCategory={this.onSelectCategory}
          regexCategories={regexCategories}
        />
      </div>
    );
  }
}

export default SearchDesktop;
